import { MatPaginatorIntlFa } from './fa-paginator';
import { MatPaginatorIntlEn } from './en-paginator';

export function createPaginatorLabel() {
	const lang = localStorage.getItem('language');
	if (lang === 'fa') {
		return new MatPaginatorIntlFa();
	} else {
		return new MatPaginatorIntlEn();
	}
}